import React from 'react';
import { MODE_OF_TRANSPORT } from '../../../../models/Onboarding/onboarding-values';
import { ICandidateDetails } from '../../../../store/superadmin/types';

interface NextOfKinProps {
    showEmergencyInfo: boolean;
    reviewCandidateData: ICandidateDetails | null;

}
const NextOfKin: React.FC<NextOfKinProps> = ({showEmergencyInfo, reviewCandidateData}) => {
    const emergencyInfo = reviewCandidateData?.emergency_info ?? null;
    
    return (
       <>
        <div className={`d-flex flex-column gap-20 fw-400 text-black ${showEmergencyInfo ? "" : "d-none"}`}>
            <div className="fs-22">Next of Kin</div>
            <div className='d-flex flex-column gap-20'>
                <div className="gap-10">
                    <div className="fs-13 text-grey-medium">
                        First Name
                    </div>
                    <div className="fs-16">
                        {emergencyInfo ? emergencyInfo?.first_name : "No data"}
                    </div>
                </div>
                <div className="gap-10">
                    <div className="fs-13 text-grey-medium">
                        Last Name
                    </div>
                    <div className="fs-16">
                        {emergencyInfo ? emergencyInfo?.last_name : "No data"}
                    </div>
                </div>
                <div className="gap-10">
                    <div className="fs-13 text-grey-medium">
                        Phone Number
                    </div>
                    <div className="fs-16">
                        {emergencyInfo ? emergencyInfo?.phone_number : "No data"}
                    </div>
                </div>

                 <div className="gap-10">
                    <div className="fs-13 text-grey-medium">
                        Relationship
                    </div>
                    <div className="fs-16">
                        {emergencyInfo ? emergencyInfo?.relationship : "No data"}
                    </div>
                </div>
            </div>
            
        </div>
       </>
    );
};

export default NextOfKin;